"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Auth = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Auth.Spec';
const Role = User.GlobalUserRole.enums;
const SatResponse = openapi_1.Response.Success(Auth.Sat).annotations({
    description: 'Created short-lived access token',
});
const createSat = platform_1.HttpApiEndpoint.post('createSat') `/sat`
    .setPayload(Auth.CreateSatPayload)
    .addSuccess(SatResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Create Short-Lived Access Token')
    .annotate(platform_1.OpenApi.Description, 'Creates a short-lived access token for direct links to a device on endpoints that accept SatCredential authentication. The caller must already be able to access that device; otherwise the API returns 404.')
    .pipe(openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager), openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.auth')
    .add(createSat)
    .prefix('/admin/auth')
    .annotate(platform_1.OpenApi.Title, 'Auth')
    .annotate(platform_1.OpenApi.Description, 'Admin authentication endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map